import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=572dff2f&"
import script from "./EditPassword.vue?vue&type=script&lang=ts&"
export * from "./EditPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports